import React from 'react';
import { connect } from 'react-redux';
import { merge, equals } from 'ramda';

const MeasureToggle = ({ retailNettMeasure, changeMeasure }) => {
  const getStyle = value => merge({
    width: '50%',
    borderRadius: '3px',
    display: 'inline-block',
    cursor: 'pointer',
  }, {
    backgroundColor: equals(value, retailNettMeasure) ? '#009688' : '#dddddd',
    color: equals(value, retailNettMeasure) ? 'white' : 'rgba(0, 0, 0, 0.3)',
  })
  return (
    <div style={{ width: '100%', display: 'inline-block', lineHeight: '24px', textAlign: 'center', fontSize: '12px' }}>
      <div style={getStyle('percentage')} onClick={() => changeMeasure('percentage')}>%</div>
      <div style={getStyle('dollar')} onClick={() => changeMeasure('dollar')}>$</div>
    </div>
  );
};

export default MeasureToggle;



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/measureToggle.jsx